import "core-js/modules/es.array.map";

var _Container, _Icon, _Separator;

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Container, EditorUserTypeIcon, Icon, Link, Separator } from "../../../../../../Common";
import { Text } from "../../../../../../Typography";
import { useTheme } from "../../../../../../../theme";
import { ToogleSwitch } from "../../../../../../Controls";
import { useHeaderContext } from '../../../../HeaderContext';
import styles from './ProfileNav.scss';

var ProfileNav = function ProfileNav(_ref) {
  var profileLinks = _ref.profileLinks,
      onLogOut = _ref.onLogOut;

  var _useTranslation = useTranslation('headerUi'),
      t = _useTranslation.t;

  var _useHeaderContext = useHeaderContext(),
      user = _useHeaderContext.user;

  var _useTheme = useTheme(),
      globalTheme = _useTheme.globalTheme,
      setGlobalTheme = _useTheme.setGlobalTheme,
      isChangeDisabled = _useTheme.isChangeDisabled;

  var userContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
    size: "large",
    userName: user.username,
    src: user.avatar
  }), /*#__PURE__*/React.createElement(Container, {
    marginLeft: 1.5
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.usernameWrap
  }, /*#__PURE__*/React.createElement(Text, null, user.username), user.isEditor && (_Container || (_Container = /*#__PURE__*/React.createElement(Container, {
    marginLeft: 1
  }, /*#__PURE__*/React.createElement(EditorUserTypeIcon, null))))), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "label"
  }, user.roleLabel)));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.profileInfoWrap
  }, user.profileLink ? /*#__PURE__*/React.createElement(Link, {
    to: user.profileLink,
    className: styles.profileInfoHeader
  }, userContent) : /*#__PURE__*/React.createElement("div", {
    className: styles.profileInfoHeader
  }, userContent), profileLinks.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Link, {
      key: String(i),
      to: item.href,
      className: styles.profileInfoLink
    }, /*#__PURE__*/React.createElement(Icon, {
      name: item.icon
    }), /*#__PURE__*/React.createElement(Container, {
      marginLeft: 1.5
    }, /*#__PURE__*/React.createElement(Text, {
      color: "label"
    }, item.title)));
  }), onLogOut && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.profileInfoLink,
    onClick: onLogOut
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    name: "exit"
  })), /*#__PURE__*/React.createElement(Container, {
    marginLeft: 1.5
  }, /*#__PURE__*/React.createElement(Text, {
    color: "label"
  }, t('LOGOUT_BTN_TEXT')))), !isChangeDisabled && globalTheme && /*#__PURE__*/React.createElement(React.Fragment, null, _Separator || (_Separator = /*#__PURE__*/React.createElement(Separator, {
    marginTop: 1.5,
    marginBottom: 1.5
  })), /*#__PURE__*/React.createElement(ToogleSwitch, {
    isOn: globalTheme === 'dark',
    onToogle: function onToogle() {
      return setGlobalTheme(globalTheme === 'dark' ? 'light' : 'dark');
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "label"
  }, t('DARK_THEME')))));
};

export default ProfileNav;